import styled from 'styled-components';
import { media } from '@minecraft.themes';
import { Loading } from '@minecraft.loader';

export const ImageGalleryWrapper = styled.div`
  .image-gallery {
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    position: relative;
  }

  .image-gallery-thumbnails-container {
    overflow: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .image-gallery-thumbnail {
    outline: none;
    border: none;
    transition: border-color 0.25s;
    vertical-align: middle;
    width: auto;
    background: none;

    &:not(:first-of-type) {
      margin-left: 0.875rem;
    }

    &:hover,
    &:focus {
      img {
        border: 3px solid ${(props): string => props.theme.colors.primary.white};
      }
    }

    &.active {
      img {
        border: 3px solid ${(props): string => props.theme.colors.primary.white};
      }
    }
  }

  .image-gallery-slide-wrapper {
    margin-bottom: 2.25rem;
    padding-bottom: 2rem;
    position: relative;
  }

  .image-gallery-index {
    position: absolute;
    background: none;
    font-size: 0.875rem;
    font-weight: normal;
    left: 0;
    right: 0;
    bottom: 0 !important;
    text-align: center;
    top: initial;
    padding: 0;
    color: ${(props): string => props.theme.colors.primary.white} !important;
  }

  .image-gallery-slides {
    line-height: 0;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
    text-align: center;
  }

  .image-gallery-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 24.75rem;
    flex-direction: column;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    &.center {
      position: relative;
    }
  }

  .image-gallery-content {
    &.bottom {
      position: relative;
      line-height: 0;
      top: 0;
    }
  }

  ${media.sm`
    .image-gallery-slide {
      min-height: 21.0625rem;
    }
  `}
`;

export const OverlayLayout = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1071;
  overflow: auto;
`;

export const OverlayWrapper = styled.div`
  max-width: 90rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledLoading = styled(Loading)`
  margin: auto;
`;
